import { useState } from "react";
import { API_URL } from "@src/config/apiconfig";

export const useFormSubmission = () => {
  const [submitting, setSubmitting] = useState(false);
  const [submitMsg, setSubmitMsg] = useState(null);
  const [submittedFormData, setSubmittedFormData] = useState(null);

  const submitForm = async (formData) => {
    setSubmitting(true);
    setSubmitMsg(null);

    try {
      const response = await fetch(API_URL.SAVE_FORM_DATA, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      let responseBody = null;
      try {
        responseBody = await response.json();
      } catch {}

      if (response.ok && responseBody && responseBody.status === "success") {
        setSubmittedFormData(formData);
        return { success: true };
      } else {
        setSubmitMsg("Something went wrong. Please try again.");
        return { success: false };
      }
    } catch (error) {
      setSubmitMsg("Something went wrong. Please try again.");
      return { success: false };
    } finally {
      setSubmitting(false);
    }
  };

  const submitWarrantyUpdate = async (warrantyChecked) => {
    if (!warrantyChecked || !submittedFormData) return;

    try {
      await fetch(API_URL.SAVE_EXTENDED_WARRANTY, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...submittedFormData,
          consent: 1,
        }),
      });
    } catch {}
  };

  return {
    submitting,
    submitMsg,
    submitForm,
    submitWarrantyUpdate,
  };
};
